<template>
    <div class="widget analytics">
        <div v-if="hasData">
            <div class="panels">
                <div class="panel cols-2">
                    <overview
                        :current-show-hash="currentShowHash"
                        :description="description"
                        :title="title"
                        @showChange="newShowHash => showHash = newShowHash"
                        @rangeChange="newRange => range = newRange"
                    />
                </div>

                <slot v-bind="{ range, ready, showHash }" />
            </div>
        </div>
        <placeholder v-else :current-show-hash="currentShowHash" />
    </div>
</template>

<script>

/**
 * External dependencies
 */
import { mapGetters } from 'vuex';

/**
 * Internal dependencies
 */
import * as components from '@/components/Analytics';

export default {
    components: {
        ...components,
    },

    props: {
        description: {
            type: String,
            default: null,
        },
        currentShowHash: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: 'Overview',
        },
    },

    data: () => ({
        range: {},
        showHash: null,
        ready: false,
    }),

    computed: {
        ...mapGetters(['hasAnalyticsData']),

        /**
         * Returns true if there are analytics data available.
         *
         * @returns {boolean} If there are analytics data.
         */
        hasData() {
            return this.currentShowHash
                ? !! this.$store.state.shows[this.currentShowHash]?.totalListens
                : this.hasAnalyticsData;
        },
    },

    /**
     * Sets `ready` flat.
     *
     * @returns {void}
     */
    mounted() {
        this.ready = true;
    },
};
</script>
